<script>
import { mapGetters } from 'vuex';

import { computedPbxBasePlans } from '@/common/service/computers/plans/pbx';

import BuyNow from './buy-now.vue';
import Add from './add.vue';
import Edit from './edit.vue';
import Upgrade from './upgrade.vue';

export default {
  computed: {
    ...mapGetters(['boughtPlans', 'migratePlanState', 'basicConfig']),

    hasBoughtPbxBasePlan(){
      return !!computedPbxBasePlans(this.boughtPlans).length;
    },
  },
  render() {
    const ctx = { ...{ props: { ...this.$props } }, on: { ...this.$listeners } }

    if (this.$context.is.esc2escp || this.migratePlanState.is.esc2escp) return <Upgrade { ...ctx } />

    if (this.$context.is.edit) return <Edit { ...ctx } />;

    if (this.$context.is.add2cart) {
      if (this.basicConfig?.isBulkLicenseAccount) return <Add { ...ctx } />;

      if (this.hasBoughtPbxBasePlan) return <Edit { ...ctx } />;

      return <Add { ...ctx } />;
    }

    if (this.$context.is.buyNow || this.$context.is.basic2pro) return <BuyNow  { ...ctx } />

    return null
  }
}
</script>
